import React, { useState } from "react";
import PhoneInput from "react-phone-number-input";
import { useSelector, useDispatch } from "react-redux";
import useInputChange from "../../../utils/hooks/useInputChange";
import { useLocation } from "react-router-dom";
import { isEmptyObject } from "../../../utils/validators/validators";
import { setApplicationInfo } from "../../../redux/slice/customer/customerSlice";
import { useEffect } from "react";
import Form from "../../form/Form";
import { onlySpaces } from "./../../../utils/validators/validators";
import { flashMessage } from "../../../utils/flash";

const ContactInformation = ({ idInfoRef }) => {
  const { application_info } = useSelector((state) => state.customer);
  const [userInput, setUserInput] = useState({
    email: "",
    phone_no: "",
    residential_address: "",
  });
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState({});
  const [phoneNumber, setPhoneNumber] = useState("");
  const [input, handleChange] = useInputChange(
    application_info,
    setUserInput,
    error,
    setError
  );

  const handlePhoneNumberChange = (phone_no) => {
    setUserInput({ ...userInput, phone_no: phone_no });
  };

  const dispatch = useDispatch();
  const location = useLocation();

  const handleSubmit = () => {
    if (isEmptyObject(error)) {
      if (!userInput?.phone_no) {
        flashMessage("error", "Please enter phone number");
      } else {
        idInfoRef.current.click();
      }
    }
  };

  useEffect(() => {
    dispatch(setApplicationInfo(userInput));
  }, [userInput]);

  return (
    <div className='border border-top-0 px-3 py-3'>
      {/* 
            email/company, phone, residential/business adres, city/town 
            */}
      <Form setError={setError} submitHandler={handleSubmit} values={userInput}>
        <div className='row mb-2'>
          <div className='mb-0 mt-3 col-md-6'>
            <label
              htmlFor='inputEmail4'
              className='form-label d-flex align-baseline'
            >
              <span>Email</span>
            </label>
            <input
              textname='email'
              name='email'
              onChange={handleChange}
              value={input.email}
              type='text'
              id='email'
              className={`form-control ${error.email && "is-invalid"}`}
              placeholder='Enter Email'
              validate='false'
            />
            {error.email && (
              <span className='invalid-feedback'>{error.email}</span>
            )}
          </div>
          <div className='col-md-6 mt-3'>
            <label htmlFor='inputEmail4' className='form-label'>
              Phone Number
              <span className='text-danger'>*</span>
            </label>

            <PhoneInput
              placeholder='Enter phone number'
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              defaultCountry='NG'
              className='form-control custom-phone-input'
            />
            {isUploading && (
              <span className='bg-dar ms-1 text-danger'>
                {" "}
                <i
                  className={`mdi mdi-dots-circle mdi-spin fs-5 h3 mt-0`}
                ></i>{" "}
              </span>
            )}
            {!isUploading && application_info?.document_url && (
              <span className='bg-dar ms-1 text-success'>
                {" "}
                <i className={`mdi mdi-check fs-5 h3 mt-0`}></i>{" "}
              </span>
            )}
            {/* {onlySpaces(phoneNumber) && (
              <span className='text-danger'>please enter phone number</span>
            )} */}
          </div>

          {/* <div className="mb-0 mt-3 col-md-6">
                    <label htmlFor="inputEmail4" 
                    className="form-label d-flex align-baseline">
                    <span>Target Category</span>
                    <span className='text-danger'>*</span>
                    </label>
                    <select name="title" id="title" className='form-select'>
                        <option value="">-- select an option --</option>
                    </select>
                </div>

                <div className="mb-0 mt-3 col-md-6">
                    <label htmlFor="inputEmail4" 
                    className="form-label d-flex align-baseline">
                    <span>Target Category</span>
                    <span className='text-danger'>*</span>
                    </label>
                    <select name="title" id="title" className='form-select'>
                        <option value="">-- select an option --</option>
                    </select>
                </div> */}

          <div className='mb-0 mt-3 col-md-12'>
            <label
              htmlFor='inputEmail4'
              className='form-label d-flex align-baseline'
            >
              <span>Residential Address </span>
              <span className='text-danger'>*</span>
            </label>
            <textarea
              rows={3}
              textname='residential_address'
              name='residential_address'
              onChange={handleChange}
              value={input.residential_address}
              id='residential_address'
              className={`form-control ${
                error.residential_address && "is-invalid"
              }`}
            ></textarea>
          </div>
        </div>
        <div className='d-flex justify-content-end mb-3'>
          <button type='submit' className='btn btn-primary'>
            Proceed
          </button>
        </div>
      </Form>
    </div>
  );
};

export default ContactInformation;
